<template>
	<div class="wrap">
		<van-nav-bar style="background: #00AC70;" class="custom-nav-bar" title="农产品溯源" />
		<van-loading color="#00AC70" style="text-align: center;margin-top: 50%;" size="60" v-if="loading" text-size="20"
			vertical>
			加载中...
		</van-loading>
		<div class="container" v-else>
			<div class="banner">
				<div class="pro-img">
					<img :src="getFirstUrl(traceabilityInfo.productPicture)" alt="" class="banner_img">
				</div>
				<div class="product-desc-box">
					<div class="desc-item">
						<span class="label">产品名称<i class="forJustify"></i></span>
						<span class="value">{{ traceabilityInfo.productName || '-' }}</span>
					</div>
					<div class="desc-item">
						<span class="label">产地<i class="forJustify"></i></span>
						<span class="value">{{ traceabilityInfo.originPlace || '-' }}</span>
					</div>
					<div class="desc-item">
						<span class="label">收获时间<i class="forJustify"></i></span>
						<span class="value">{{ traceabilityInfo.harvestDate || '-' }}</span>
					</div>
					<div class="desc-item">
						<span class="label">生产批次<i class="forJustify"></i></span>
						<span class="value">{{ traceabilityInfo.productionBatch || '-' }}</span>
					</div>
					<div class="desc-item">
						<span class="label">溯源追溯码<i class="forJustify"></i></span>
						<span class="value">{{ traceabilityInfo.traceabilityCode || '-' }}</span>
					</div>
				</div>
			</div>
			<div class="title" @click="showMapApp = true">基地介绍</div>
			<div class="container-box">
				<div class="container-item base-container-item">
					<div class="desc company-name">{{ traceabilityInfo.baseName || '-' }}</div>
					<div class="desc user-name">
						<i class="icon user-icon"></i>
						{{ traceabilityInfo.basePrincipal || '-' }}
					</div>
					<div class="desc desc-text">
						<p>
							<i class="icon desc-icon"></i>
							<span>{{ traceabilityInfo.baseIntroduce || '-' }}</span>
						</p>
						<!-- 基地地图定位点 -->
						<div id="bmap" ref="bmap" :style="{width: '100%',height: '200px'}"></div>
						<img v-if="mainNoVideo.length == 1" :src="mainNoVideo[0]" alt=""
							style="width: 100%;height:320px;object-fit: cover;">
						<div v-if="mainNoVideo.length > 1" class="swipe-box">
							<van-swipe :autoplay="3500" :show-indicators="true">
								<van-swipe-item v-for="(image, index) in mainNoVideo" :key="index">
									<img :src="image" alt="" style="width: 100%;height:320px;object-fit: cover;" />
								</van-swipe-item>
							</van-swipe>
							<!-- <img v-for="(more,moreIndex) in mainNoVideo" :key="moreIndex" :src="more" alt=""> -->
							<div v-if="mainHasVideo.length>0">
								<video v-for="(vide,videoIndex) in mainHasVideo" :key="videoIndex"
									style="width: 100%;height: 200px;" v-bind:src="vide" controls="controls"
									:poster="mainNoVideo[0]">
									您的浏览器不支持视频播放
								</video>
							</div>
						</div>
<!-- 						<div class="load-more" v-if="mainNoVideo.length > 1 " @click="isLoadMore = !isLoadMore">更多基地信息
							<van-icon :name="isLoadMore?'arrow-up':'arrow-down'" />
						</div> -->
					</div>
				</div>
			</div>
			<div class="title" v-if="examiningReportList.length">检测报告</div>
			<div class="container-box" v-for="(reportItem,reportIndex) in examiningReportList" :key="reportIndex">
				<div class="container-item">
					<img :src="reportItem" alt="检测报告" class="fram-wrok" @click="preview(reportItem)">
				</div>
			</div>
			<div v-if="traceabilityInfo.harvestResource">
				<div class="title">收获信息</div>
				<div class="container-box" v-for="(farm,farmIndex) in filterLists(traceabilityInfo.harvestResource)"
					:key="farmIndex">
					<div class="container-item">
						<div>
							<img :src="farm.path" alt="" class="fram-wrok" v-if="harvestType(farm) == 1">
							<div class="video-box" v-if="harvestType(farm) == 2">
								<img :src="farm.screenshotPath" alt="" class="poster-img">
								<div class="play-icon" @click="videoPlay(farm)">
								</div>
							</div>
						</div>
						<div class="bottom-box">
							<div class="fram-desc">
								<div v-if="traceabilityInfo.harvestRemark"><i
										class="icon fram1"></i>{{ traceabilityInfo.harvestRemark || '-' }}
								</div>
								<div v-if="traceabilityInfo.harvestDate"><i
										class="icon fram2"></i>发布日期：{{ traceabilityInfo.harvestDate || '-' }}
								</div>
								<div v-if="traceabilityInfo.harvestShootLocation"><i
										class="icon farm3"></i>拍摄位置：{{ traceabilityInfo.harvestShootLocation || '-' }}
								</div>
								<div v-if="traceabilityInfo.harvestShootDate"><i
										class="icon fram2"></i>拍摄日期：{{ traceabilityInfo.harvestShootDate || '-' }}
								</div>
								<div v-if="traceabilityInfo.harvestWeather"><i
										class="icon farm5"></i>天气：{{ traceabilityInfo.harvestWeather || '-' }} ·
									温度{{ traceabilityInfo.harvestTemperature || '-' }}℃ /
									湿度{{ traceabilityInfo.harvestHumidity || '-' }}%
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="baseFarmWork.length">
				<div class="title">农事信息</div>
				<van-list v-model="listLoading" :finished="listFinished" :immediate-check="false" finished-text="没有更多了"
					@load="loadMore" :offset="10">
					<!-- 节点得形式展示 -->
					<div class="node-item-box" v-for="(farm,farmIndex) in baseFarmWork" :key="farmIndex"
						:class="{'node-item-box-last': farmIndex == baseFarmWork.length - 1}">
						<div class="node-item-header">
							<p class="node-item-date">{{farm.releaseDate}}</p>
							<p class="node-item-text">{{farm.remark}}</p>
						</div>
						<div class="node-item-content">
							<div class="node-item-content-inner" v-show="farm.resourceUrl">
								<img v-for="(urlItem,urlIndex) in filterLists(farm.resourceUrl)"
									:src="urlItem.screenshotPath ? urlItem.screenshotPath : urlItem.path" alt=""
									class="node-item-pic" @click="lookMoreFarmDetail(farm)">
							</div>
						</div>
					</div>
				</van-list>
			</div>
		</div>
		<van-overlay :show="previewShow" @click="previewShow = false" :z-index="1000">
			<div class="previewWrapper">
				<img :src="previewSrc" alt="">
			</div>
		</van-overlay>
		<van-overlay :show="videoShow" @click="closeVideo()" :z-index="1001">
			<div class="video-box" v-if="videoShow">
				<div class="video-title">视频预览</div>
				<div class="close_icon" @click="closeVideo">
					<van-icon name="close" color="#fff" size="24"></van-icon>
				</div>
				<!-- :poster="videoInfo.videoPoster" -->
				<video width="100%" height="85%" style="z-index:100;" :src="videoInfo.videoSrc" controls="true"
					play-btn-position="center" autoplay></video>

			</div>
		</van-overlay>
		<!--    小程序二维码 animate__animated animate__bounceInRight -->
<!--		<div class="qr_box" v-if="!loading">-->
<!--			<img class="qr_img"-->
<!--				src="../assets/img/erCode.jpg"-->
<!--				alt="">-->
<!--			<span class="tip_text">长按二维码识别进入商城购买农产品</span>-->
<!--			&lt;!&ndash;      <wx-open-launch-weapp id="launch-btn" username="gh_b6ffa6ac9155" path="pages/dashboard/dashboard.html">&ndash;&gt;-->
<!--			&lt;!&ndash;        <template>&ndash;&gt;-->
<!--			&lt;!&ndash;          <van-button class="toReserveBtn" type="primary" round style="width: 200px;height: 200px;">跳转小程序</van-button>&ndash;&gt;-->
<!--			&lt;!&ndash;        </template>&ndash;&gt;-->
<!--			&lt;!&ndash;      </wx-open-launch-weapp>&ndash;&gt;-->
<!--		</div>-->
		<!--    <van-action-sheet v-model="showMapApp" description="请选择已安装APP" :actions="mapList" @select="onSelect"/>-->
		<van-popup v-model="showMapApp" position="bottom" :style="{ height: '220px' }">
			<div class="map-app-box">
				<div class="tips">请选择已安装APP</div>
				<div v-for="(map,mapIndex) in mapList" :key="mapIndex" class="maps" @click="onSelect(map)">{{map.name}}
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script type="text/javascript">
	import wx from 'weixin-js-sdk'

	export default {
		name: "dashboard",
		data() {
			return {
				showMapApp: false, //已安装App列表
				mapList: [{
					id: 1,
					name: '腾讯地图'
				}, {
					id: 2,
					name: '百度地图'
				}, {
					id: 3,
					name: '高德地图'
				}],
				addressPoint: {
					lat: '29.305238',
					lng: '118.211435'
				}, //导航所需信息
				isLoadMore: false,
				mainHasVideo: [],
				mainNoVideo: [],
				videoIndex: '',
				mainImagelist: [],
				loading: false,
				paramsInfo: {
					id: 4,
					regionProductId: "", //根据商品id查询收获记录的农事记录
				}, // 商品溯源保存数据
				traceabilityInfo: {}, //溯源信息
				baseFarmWork: [], //农事记录
				examiningReportList: [], //检测报告
				previewShow: false, //预览图片
				previewSrc: '', //预览的图片
				videoShow: false,
				videoInfo: {
					videoSrc: "",
					videoPoster: ""
				}, //预览的全屏图片
				listLoading: false,
				listFinished: false,
				page: 1,
				pageSize: 10,
				total: 0,
				baseMarketInfo: {
					longitude: '',
					latitude: '',
					name: ''
				}, //基地经纬度
				oldScrollTop: 0, //记录上一次滚动结束后的滚动距离
				scrollTop: 0, // 记录当前的滚动距离
				qrClass: '', //图片类名
				wxHtml: ''
			}
		},
		watch: {
			/***Description 此处监听上传的数据是否包含视频来控制接下来上传的数据*/
			mainImagelist(val) {
				if (val) {
					console.log(val, '获取到接口的图片')
					let videoUrl = val.filter(img => {
						return img.indexOf('.mp4') !== -1
					});
					console.log(videoUrl, 'videoUrl')
					let noVideo = val.filter(img => {
						return img.indexOf('.mp4') === -1
					});
					console.log(noVideo, 'noVideo')
					let videoIndex = val.findIndex((item, index) => {
						return item.indexOf('.mp4') !== -1;
					});
					console.log(videoIndex, 'videoIndex')
					this.videoIndex = videoIndex;
					if (videoUrl.length > 0) {
						this.mainHasVideo = videoUrl;
					}
					this.mainNoVideo = noVideo;
					console.log(this.mainNoVideo, '基地图片======')
				}
			},
			scrollTop(newValue, oldValue) {
				setTimeout(() => {
					if (newValue == window.scrollY) { //延时执行后当newValue等于window.scrollY，代表滚动结束
						console.log(newValue, '滚动结束');
						this.oldScrollTop = newValue; //每次滚动结束后都要给oldScrollTop赋值
						if (newValue > 300) {
							this.qrClass = 'animate__bounceInRight'
						} else {
							this.qrClass = 'none'
						}
					}
				}, 20); //必须使用延时器，否则每次newValue和window.scrollY都相等，无法判断，20ms刚好大于watch的侦听周期，故延时20ms
				if (this.oldScrollTop == oldValue) { //每次滚动开始时oldScrollTop与oldValue相等
					console.log(oldValue, '滚动开始');
					this.qrClass = 'none'
				}
			}
		},
		methods: {
			/** @Description:  跳转至导航App*/
			onSelect(item) {
				console.log(item);
				let longitude = this.baseMarketInfo.longitude,
					latitude = this.baseMarketInfo.latitude
				let name = this.baseMarketInfo.name;
				let url = "";
				const u = navigator.userAgent;
				const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
				const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
				if (isAndroid) {
					switch (item.id) {
						//下面是拼接url,不同系统以及不同地图都有不同的拼接字段
						case 1:
							//注意referer=xxx的xxx替换成你在腾讯地图开发平台申请的key
							url = `qqmap://map/geocoder?coord=${latitude},${longitude}&referer=xxx`;
							break;
						case 2:
							url =
								`baidumap://map/marker?location=${latitude},${longitude}&title=${name}&coord_type=gcj02&src=andr.baidu.openAPIdemo`;
							break;
						case 3:
							url =
								`androidamap://viewMap?sourceApplication=appname&poiname=${name}&lat=${latitude}&lon=${longitude}&dev=0`;
							break;
						default:
							break;
					}
					if (url != "") {
						window.open(url, "_blank")
					}
				} else if (isiOS) {
					switch (item.id) {
						case 1:
							url = `qqmap://map/geocoder?coord=${latitude},${longitude}&referer=xxx`;
							break;
						case 2:
							url =
								`baidumap://map/marker?location=${latitude},${longitude}&title=${name}&content=${name}&src=ios.baidu.openAPIdemo&coord_type=gcj02`;
							break;
						case 3:
							url =
								`iosamap://viewMap?sourceApplication=applicationName&poiname=${name}&lat=${latitude}&lon=${longitude}&dev=0`;
							break;
						default:
							break;
					}
					if (url != "") {
						window.location.href = url;
					}
				}
			},
			/** @Description:  显示本地导航软件*/
			showMapDialog(item) {
				console.log(item, '点击地图点获取到的数据');
				this.showMapApp = true;
			},
			/**
			 * 获取第一张图片
			 */
			getFirstUrl(url) {
				return url ? url.split('~')[0] : ''
			},
			/**
			 * 获取所有得图片地址
			 */
			getAllUrl(url) {
				return url.length ? url[0].split('~') : []
			},
			/**
			 * 图片预览
			 */
			preview(picUrl) {
				console.log(picUrl)
				this.previewShow = true;
				this.previewSrc = picUrl;
			},
			/**
			 * 判断数据类型
			 */
			resourceType(src) {
				if (src.screenshotPath || src.path.includes('.mp4')) {
					return 2
				} else {
					return 1
				}
			},
			/**
			 * 判断收获类型
			 */
			harvestType(src) {
				if (src.screenshotPath || src.path.includes('.mp4')) {
					return 2
				} else {
					return 1
				}
			},
			/**
			 * 获取过滤完的图片
			 */
			filterLists(src) {
				let list = src ? JSON.parse(src) : [];
				return list
			},
			/**
			 * 播放视频
			 */
			videoPlay(e) {
				console.log(e, '绑定元素')
				this.videoShow = true;
				this.videoInfo.videoSrc = e.path;
				this.videoInfo.videoPoster = e.screenshotPath;
			},
			/**
			 * 全屏视频关闭
			 */
			closeVideo() {
				this.videoShow = false;
				this.videoInfo.videoSrc = "";
				this.videoInfo.videoPoster = ""
			},
			/**
			 * 根据id 查询溯源信息
			 */
			async getTraceabilityRecordById() {
				let that = this;
				let params = {
					id: that.paramsInfo.id
				}
				let recordById = (id) => this.$request.get(
					`/bases-consumer/webapp/terminal/getTraceabilityRecordById/${id}`);
				const result = await recordById(params.id)
				console.log(result, '溯源数据')
				if (result) {
					if (result.code == 200) {
						let datas = result.data || {};
						this.traceabilityInfo = datas;
						if (this.traceabilityInfo.basePicture) {
							this.mainNoVideo = this.traceabilityInfo.basePicture ? this.traceabilityInfo.basePicture
								.split('~') : [];
							// this.mainImagelist.push(this.traceabilityInfo.basePicture)
						}
						// if (this.traceabilityInfo.baseVideo) {
						// 	this.mainImagelist.push(this.traceabilityInfo.baseVideo)
						// }
						this.examiningReportList = this.traceabilityInfo.examiningReport ? this.traceabilityInfo
							.examiningReport.split('~') : [];
						this.paramsInfo.regionProductId = this.traceabilityInfo.regionProductId;
						this.baseMarketInfo.latitude = this.traceabilityInfo.baseLatitude;
						this.baseMarketInfo.longitude = this.traceabilityInfo.baseLongitude;
						this.baseMarketInfo.name = this.traceabilityInfo.baseName;
						this.getList();
						setTimeout(() => {
							this.initMap()
						}, 3000)
					}
				}
			},
			/**
			 * 获取农事记录数据
			 */
			getList() {
				let that = this;
				let params = {
					pageNum: this.page,
					pageSize: this.pageSize,
					params: {
						regionProductId: this.paramsInfo.regionProductId
					}
				}
				this.$request.post(`/bases-consumer/webapp/terminal/getTraceabilityFarmWork`, params)
					.then(res => {
						console.log(res.data, '农事记录数据======')
						let rows = res.data.rows;
						that.listLoading = false;
						that.total = res.data.totalCount;
						if (rows == null || rows.length == 0) {
							// 加载结束
							that.listFinished = true;
							return;
						}
						that.baseFarmWork = that.baseFarmWork.concat(rows);
						if (that.baseFarmWork.length >= that.total) {
							that.listFinished = true;
						}
					})
			},
			/**
			 * 加载更多数据
			 */
			loadMore() {
				this.page++;
				this.getList()
			},
			/**
			 * 初始化地图 基地位置
			 */
			initMap() {
				console.log('触发=====')
				// 百度地图API功能
				console.log(this.baseMarketInfo, '基地经纬度')
				const {
					longitude,
					latitude,
					name
				} = this.baseMarketInfo;
				const that = this;
				let map = new BMap.Map('bmap', {
					mapType: BMAP_HYBRID_MAP
				}, {
					// enableMapClick: false
				}) // 创建Map实例
				if (longitude && latitude) {
					map.centerAndZoom(new BMap.Point(longitude, latitude), 16) // 初始化地图,设置中心点坐标和地图级别
				} else {
					map.centerAndZoom(new BMap.Point(121.105164, 30.659539), 16) // 林埭镇
				}
				// map.centerAndZoom(new BMap.Point(120.761249, 30.755691), 14) // 初始化地图,设置中心点坐标和地图级别
				map.setCurrentCity('衢州市') // 设置地图显示的城市 此项是必须设置的
				map.disableDragging(); //禁止拖拽
				// map.enableScrollWheelZoom(false)
				const markersList = [{
					longitude: longitude,
					latitude: latitude,
					name: name
				}];
				for (let i = 0; i < markersList.length; i++) {
					// 创建小车图标
					const icon = require('../assets/img/market.png')
					let myIcon = new BMap.Icon(icon, new BMap.Size(26, 50));
					let points = new BMap.Point(markersList[i].longitude, markersList[i].latitude) //创建坐标点
					let markersIcon = new BMap.Marker(points, {
						icon: myIcon
					})
					map.addOverlay(markersIcon);
					markersIcon.addEventListener("click", function(e) {
						console.log(e.target, '点我了', markersList[i]);
						that.showMapDialog(markersList[i]);
					})
				}
			},
			/** @Description:  监听页面是否已经滚动结束*/
			handleScroll() {
				this.scrollTop = window.scrollY;
			},
			initWxConfig() {
				let configData = {};
				this.$request.get(`https://it97xy.cn:8000/api/wx/jsapi_ticket`)
					.then(res => {
						console.log(res.data, '获取参数');
						configData = res.data;
						wx.config({
							debug: false, // 这里一般在测试阶段先用ture，等打包给后台的时候就改回false,
							appId: 'wx454fe070b9e94aab', // 必填，公众号的唯一标识
							timestamp: configData.timestamp, // 必填，生成签名的时间戳
							nonceStr: configData.nonceStr, // 必填，生成签名的随机串
							signature: configData.signature, // 必填，签名
							jsApiList: ["openLocation"], // 必填，需要使用的JS接口列表。这个参数我没看懂，所以瞎填了一个
							// openTagList: ['wx-open-launch-weapp'] // 可选，跳转小程序使用['wx-open-launch-weapp']，跳转APP使用['wx-open-launch-app']
						});
						// this.getHtml();
					}).catch(() => {
						console.log('报错==========')
					})
			},
			getHtml() {
				this.$nextTick(() => {
					let launchButton = document.getElementById('launch-btn')
					if (launchButton) {
						launchButton.addEventListener('launch', function(e) {
							console.log('success', e)
						})

						launchButton.addEventListener('error', function(e) {
							console.log('fail', e)
						})
					}
				});
			},
			/**
			 * 查看详细的农事信息
			 */
			lookMoreFarmDetail(farm) {
				sessionStorage.setItem('shopFarmDetail', JSON.stringify(farm))
				this.$router.push({
					path: '/farm/detail'
				})
			}
		},
		created() {
			// this.initWxConfig();
		},
		mounted() {
			// window.addEventListener('scroll', this.handleScroll, true);
			// 监听（绑定）滚轮 滚动事件
			this.loading = true;
			if (this.$route.query.id) {
				this.paramsInfo.id = this.$route.query.id;
			}
			this.mainImagelist = [];
			setTimeout(() => {
				this.loading = false;
			}, 2000)
			this.getTraceabilityRecordById();
		}
	}
</script>

<style lang="scss" scoped>
	.wrap {
		min-height: 100vh;
		height: auto;
		background-color: #FFFFFF !important;
	}
	.map-app-box {
		text-align: center;
		padding: 50px 0;

		.tips {
			font-size: 32px;
			margin-bottom: 30px;
		}

		.maps {
			font-size: 26px;
			padding: 20px 0;
			border-bottom: 1px solid #ebedf0;
		}
	}

	#bmap {
		width: 100%;
		height: 200px;
		margin-top: 15px;
	}

	.qr_box {
		width: 300px;
		// position: fixed;
		// right: 0;
		// top: 50%;
		margin: 0 auto;
		z-index: 9999;
		text-align: center;
		background: transparent;
		border-radius: 20px;
		padding: 10px 10px;
		display: flex;
		flex-direction: column;
		background: #FFFFFF;

		.tip_text {
			font-size: 26px;
			width: 100%;
			padding-bottom: 20px;
		}

		.qr_img {
			width: 100%;
			height: 300px;
			border-radius: 20px;
		}
	}

	.none {
		display: none;
	}

	.banner {
		width: 750px;
		min-height: 880px;
		background: url("../assets/img/banner.png") no-repeat;
		background-size: 100% 100%;
		padding: 0 20px;
		box-sizing: border-box;

		.pro-img {
			padding-top: 20px;
			text-align: center;

			.banner_img {
				width: 100%;
				height: 400px;
				border-radius: 16px;
				object-fit: cover;
			}
		}

		.product-desc-box {
			.desc-item {
				height: 50px;
				line-height: 50px;
				margin: 30px 0;

				.label {
					display: inline-block;
					width: 178px;
					height: 45px;
					line-height: 45px;
					background: rgba(0, 172, 112, 0.1);
					font-size: 26px;
					color: #00AC70;
					border-radius: 27px;
					text-align: justify;
					text-align-last: justify;
					padding: 0 20px;
					overflow: hidden;
					vertical-align: top;

					.forJustify {
						display: inline-block;
						width: 100%;
					}
				}

				.value {
					display: inline-block;
					vertical-align: top;
					max-width: 400px;
					line-height: 45px;
					margin-left: 30px;
					font-size: 26px;
					font-weight: 400;
					color: #333333;
				}
			}
		}
	}

	.title {
		width: 100%;
		height: 80px;
		line-height: 80px;
		background: url("../assets/img/titleBj.png") no-repeat;
		background-size: contain;
		background-position: center;
		font-size: 30px;
		font-weight: bold;
		color: #333333;
		margin: 40px 0;
		text-align: center;
	}

	.container-box {
		margin: 20px;
		min-height: 637px;
		border: 1px solid #00AC70;
		padding: 10px;

		.container-item {
			padding: 22px;
			border: 1px solid #00AC70;
			min-height: 637px;
			font-size: 26px;
			position: relative;

			.desc {
				padding: 10px 0;
			}

			.company-name {
				font-size: 26px;
				color: #00AC70;
			}

			.user-name,
			.desc-text {
				color: #666666;
			}

			.icon {
				display: inline-block;
				width: 26px;
				height: 26px;
				margin-right: 10px;
				vertical-align: middle;
			}

			.user-icon {
				background: url("../assets/img/userIcon.png") no-repeat;
				background-size: 100% 100%;
			}

			.desc-icon {
				background: url("../assets/img/descIcon.png") no-repeat;
				background-size: 100% 100%;
			}

			img {
				width: 100%;
				height: 100%;
				border-radius: 16px;
				// margin: 20px 0;
			}

			.load-more {
				width: 100%;
				text-align: center;
			}

			.fram-wrok {
				height: 904px;
				background: #00AC70;
				border-radius: 10px;
				object-fit: cover;
			}

			.bottom-box {
				width: calc((100% - 40px));
				min-height: 260px;
				height: auto;
				background: linear-gradient(0deg, #009F68 0%, rgba(0, 159, 104, 0) 100%);
				border-radius: 10px;
				position: absolute;
				bottom: 22px;

				.fram-desc {
					color: #ffffff;
					font-size: 26px;
					position: absolute;
					bottom: 0;
					padding: 0 20px;

					&>div {
						padding: 15px 0;
					}
				}
			}

			.fram1 {
				background: url("../assets/img/fram1.png") no-repeat;
				background-size: 100% 100%;
			}

			.fram2 {
				background: url("../assets/img/time.png") no-repeat;
				background-size: 100% 100%;
			}

			.farm3 {
				background: url("../assets/img/address_icon.png") no-repeat;
				background-size: 100% 100%;
			}

			.farm5 {
				background: url("../assets/img/weather_icon.png") no-repeat;
				background-size: 100% 100%;
			}

			.video-item {
				width: 100%;
				height: 1104px;
				object-fit: fill;
			}

			.video-box {
				.play-icon {
					width: 100px !important;
					height: 100px !important;
					background: url(../assets/img/play.png) no-repeat;
					background-size: cover;
					z-index: 1000;
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%, -50%);
				}
			}
		}

		.base-container-item {
			img {
				margin: 20px 0;
			}
		}
	}

	.video-box {
		position: relative;
		width: 100%;
		height: 1104px;

		.poster-img {
			width: 100%;
			height: 1004px !important;
			object-fit: fill;
		}
	}

	.previewWrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;

		img {
			width: 80%;
			height: auto;
		}
	}

	.video-box {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;

		.video-title {
			position: absolute;
			top: 30px;
			left: 0;
			width: 100%;
			height: 30px;
			text-align: center;
			line-height: 60 rpx;
			color: #FFFFFF;
			font-size: 24 rpx;
		}

		.close_icon {
			position: absolute;
			right: 20px;
			top: 35px;
		}
	}

	.node-item-box {
		width: 100%;
		height: auto;
		box-sizing: border-box;
		padding: 10px 20px 0 20px;

		.node-item-header {
			width: 100%;
			height: 54px;
			display: flex;
			flex-direction: row;
			align-items: center;

			.node-item-date {
				width: 178px;
				height: 54px;
				line-height: 54px;
				background: rgba(0, 172, 112, 0.1);
				border-radius: 24px;
				font-size: 22px;
				font-family: PingFang SC;
				font-weight: 500;
				color: #00AC70;
				box-sizing: border-box;
				padding-left: 40px;
				position: relative;
				overflow: hidden;

				&::before {
					content: '';
					width: 14px;
					height: 14px;
					background: #00AC70;
					border-radius: 50%;
					clear: both;
					position: absolute;
					left: 13px;
					top: 20px;
					visibility: visible;
				}
			}

			.node-item-text {
				flex: 1;
				flex-shrink: 0;
				padding-left: 16px;
				font-size: 22px;
				font-family: PingFang SC;
				font-weight: 500;
				color: #00AC70;
				line-height: 24px;
			}
		}

		.node-item-content {
			margin: 20px 0;
			height: 196px;
			border: 1px solid #00AC70;
			box-sizing: border-box;
			background: #FFFFFF;
			position: relative;

			&::before {
				content: '';
				width: 1px;
				position: absolute;
				top: -22px;
				left: 18px;
				bottom: -30px;
				background-color: #00AC70;
				clear: both;
				visibility: visible;
			}

			&::after {
				content: '';
				position: absolute;
				left: 0;
				right: 0;
				bottom: 0;
				top: 0;
				background: #FFFFFF;
				visibility: visible;
				clear: both;
				z-index: 10;
			}

			.node-item-content-inner {
				position: absolute;
				top: 7px;
				left: 7px;
				right: 7px;
				bottom: 7px;
				border: 1px solid #00AC70;
				box-sizing: border-box;
				padding: 20px 0 20px 24px;
				background: #FFFFFF;
				z-index: 100;
				overflow: hidden;

				.node-item-pic {
					display: inline-block;
					vertical-align: top;
					width: 140px;
					height: 140px;
					margin-right: 24px;
					margin-bottom: 24px;
					object-fit: cover;
					border-radius: 10px;
				}
			}
		}
	}

	.node-item-box-last {
		.node-item-content {
			&::before {
				bottom: 0 !important;
			}
		}
	}
	.swipe-box ::v-deep .van-swipe__indicators {
		bottom: 0;
	}
	.swipe-box ::v-deep .van-swipe__indicators i {
		width: 12px;
		height: 12px;
	}
</style>
